import React from "react";

// components


export default function Chats() {
  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          {/* <LeadParent color='dark'/> */}
          <div className="bg-black">
            hi there 
          </div>
        </div>
        
      </div>
    </>
  );
}
